<template>
    <div v-if="!loading">
        <v-flex xs12 d-flex>
            <v-select v-on:change="onSelectChange" :items="searchableEquipmentList" v-model="selectedPart" box label="Equipment"></v-select>
        </v-flex>
        <v-flex xs12 d-flex>
            <div style="height:400px;" :id="mapName"></div>
        </v-flex>
    </div>
    <div v-else> 
        <v-layout style="margin:30px;">
            <v-spacer>
            </v-spacer>
            <v-spacer>
                <v-progress-circular indeterminate color="primary"></v-progress-circular>
            </v-spacer>
        </v-layout>
    </div>
</template>

<script>
const axios = require("axios");
import getSitePass from '../sitepass'
let gmapConfig = require("../configs/mapConfigs.json");

export default {
    name: "mymap",
    props: ["name"],
    data: function() {
        return {
            mapName: this.name + "-map",
            warehouseLocationList: [],
            markerArray: [],
            map: this.map,
            searchableEquipmentList: [],
            selectedPart: "",
            warehouseFullStockList: [],
            loading: true,
        };
    },
    methods: {
        initialise,
        addMarker,
        updateWarehouseList,
        initMap,
        updateSearchableEquipmentList,
        refreshWarehouseStockList,
        addItemToWarehouseList,
        onSelectChange,
        drawMarkersOnStock,
        clearMarkers
    },
    mounted() {
        this.initialise();
    }
};

function initialise() {
    this.initMap();

    this.updateSearchableEquipmentList();

    this.updateWarehouseList().then((warehouseLocationList) => {
        this.refreshWarehouseStockList();
        setTimeout(() => {
            this.warehouseLocationList.forEach((warehouseObject) => {
                this.addMarker(warehouseObject);
            });
        }, 1500);
    });
}

function updateWarehouseList() {
    return new Promise((resolve) => {
        axios
            .get(process.env.VUE_APP_backend_url + "/getWarehouseLocations", {
                params: {
                    sitepass: getSitePass()
                }
            })
            .then((result) => {
                this.warehouseLocationList = result.data;
                resolve(result);
            });
    });
}

function updateSearchableEquipmentList() {
    return new Promise((resolve) => {
        axios
            .get(process.env.VUE_APP_backend_url + "/", {
                params: {
                    sitepass: getSitePass()
                }
            })
            .then((result) => {
                result.data.forEach((part) => {
                    let partItem = `${part.Name}`;
                    this.searchableEquipmentList.push(partItem);
                });
                this.loading = false;
                resolve(result);
            });
    });
}

function onSelectChange() {
    this.clearMarkers();
    this.refreshWarehouseStockList().then(() => {
        this.drawMarkersOnStock(this.selectedPart);
    });
}

function drawMarkersOnStock(itemName) {
    this.warehouseLocationList.forEach((warehouse) => {
        if (typeof warehouse[itemName] != "undefined") {
            {
                this.addMarker(warehouse, warehouse[itemName]);
            }
        }
    });
}

function clearMarkers() {
    //Clear MARKERS.
    this.markerArray.forEach((markerItem) => {
        markerItem.marker.setMap(null);
    });
    this.markerArray = [];
}

function addMarker(warehouseObject, qty) {
    let latLng = { lat: warehouseObject.Latitude, lng: warehouseObject.Longitude };
    let qtyLabel;
    if (typeof qty == "number") {
        qtyLabel = qty.toString();
    } else {
        qtyLabel = "";
    }

    let infoWindowString = `<legend style="color:black">${warehouseObject.Warehouse}</legend>`;

    let infowindow = new google.maps.InfoWindow({
        content: infoWindowString
    });

    let marker;
    if (qty < 1) {
        marker = new google.maps.Marker({
            position: latLng,
            map: this.map,
            icon: "https://maps.google.com/mapfiles/ms/icons/yellow-dot.png"
        });
    } else {
        marker = new google.maps.Marker({
            position: latLng,
            map: this.map,
            label: qtyLabel.toString()
        });
    }

    marker.addListener("click", function() {
        infowindow.open(this.map, marker);
    });
    this.markerArray.push({ name: warehouseObject.Warehouse, marker: marker });
}

function refreshWarehouseStockList() {
    return new Promise((resolve) => {
        axios
            .get(process.env.VUE_APP_backend_url + "/getWarehouseStockForMap", {
                params: {
                    sitepass: getSitePass()
                }
            })
            .then((response) => {
                response.data.forEach((stockElement) => {
                    if (stockElement.part_name == this.selectedPart) {
                        this.addItemToWarehouseList(stockElement.part_name, stockElement.qty, stockElement.warehouse_name);
                    }
                });
                // console.log("new Stock List", this.warehouseLocationList);
                resolve();
            });
    });
}

function addItemToWarehouseList(itemName, itemQty, warehouse) {
    let warehouseIndex = this.warehouseLocationList.findIndex((iteratedWarehouse) => {
        if (iteratedWarehouse.Warehouse == warehouse) {
            return true;
        }
    });

    if (warehouseIndex > -1) {
        this.warehouseLocationList[warehouseIndex][itemName] = itemQty;
    }
}

function initMap() {
    try {
        gmapConfig.center = new google.maps.LatLng(-25.2744, 133.775);

        const options = gmapConfig;
        const element = document.getElementById(this.mapName);
        this.map = new google.maps.Map(element, options);
    } catch (e) {
        setTimeout(() => {
            this.initMap();
            // Retry the map if it doesn't load every 500ms.
        }, 500);
    }
}
</script>

<style scoped>
.google-map {
    width: 800px;
    height: 600px;
    margin: 0 auto;
    background: gray;
}
</style>


// WEBPACK FOOTER //
// src/components/map.vue